import { render, staticRenderFns } from "./f2g-tooltip.vue?vue&type=template&id=8f15c3e8&scoped=true"
import script from "./f2g-tooltip.vue?vue&type=script&lang=js"
export * from "./f2g-tooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f15c3e8",
  null
  
)

export default component.exports